import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { dAPI } from 'appSrc/api';
import { PrimaryButton } from 'appSrc/components/UI';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import EditUserModal from '../../Modals/User/EditUserModal';
import NewUserModal from '../../Modals/User/NewUserModal';
import FeaturedUsersTable from './Table';
import { showModal, hideModal } from 'appSrc/redux/actions';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';

class FeaturedUsersView extends Component {
    constructor( props ) {
        super( props );
        this.state = {
            fetching: true,
            users: [],
            searchValue: '',
            userInEdit: null,
            userInEditIndex: -1,
            userQueryObject: {
                limit: 'none',
                featured: true,
                search: undefined,
            },
        };
    }
    componentDidMount() {
        this.loadUsers();
    }
    loadUsers = () => {
        return this.props.getUsers( this.state.userQueryObject )
        .then( ( users ) => {
            this.setState( ( prevState ) => {
                prevState.fetching= false,
                prevState.users = prevState.users.concat( users ),
                prevState.userQueryObject.page++;
                return prevState;
            } );
            return users;
        } );
    }
    directUpdateUser = ( index, userid, data ) => {
        this.props.updateUser( userid, data )
        .then( ( user ) => {
            this.setState( ( prevState ) => {
                if( user.featured == null ) {
                    prevState.users = prevState.users.slice( 0, index ).concat( prevState.users.slice( index + 1 ) );
                } else {
                    prevState.users[ index ] = user;
                }
                return prevState;
            } );
        } );
    }
    openEditModal = ( index, user ) => {
        this.setState( { userInEdit: user, userInEditIndex: index } );
        this.props.showModal( 'editUserModal' );
    }
    onEditSubmit = ( updates ) => {
        var calls = [];
        if( updates.affil.length > 0 ) {
            for( var i = 0; i < updates.affil.length; i++ ) {
                calls.push( this.props.updateUserAffiliateCode( updates.affil[i].userid, updates.affil[i] ) );
            }
        }
        return Promise.all( calls )
        .then( () => {
            return this.props.updateUser( updates.user.userid, updates.user );
        } )
        .then( ( updatedUser ) => {
            this.setState( ( prevState ) => {
                prevState.users[ this.state.userInEditIndex ] = updatedUser;
                return prevState;
            } );
            return updatedUser;
        } );
    }
    onEditClose = () => {
        this.props.hideModal( 'editUserModal' );
        this.setState( { userInEdit: null, userInEditIndex: -1 } );
    }
    openNewModal = () => {
        this.props.showModal( 'newUserModal' );
    }
    onNewSubmit = ( updates ) => {
        this.props.createUser( updates.data )
        .then( ( confirmation ) => {
            var calls = [];
            if( updates.affil.length > 0 ) {
                for( var i = 0; i < updates.affil.length; i++ ) {
                    var affil = { ...updates.affil[ i ] };
                    affil.userid = confirmation.id;
                    calls.push( this.props.updateUserAffiliateCode( confirmation.id, affil ) );
                }
            }
            return Promise.all( calls );
        } )
        .then( () => {
            this.setState( ( prevState ) => {
                prevState.fetching = true;
                prevState.users = [];
                prevState.userQueryObject.page = 1;
                return prevState;
            } );
            this.loadUsers();
            return true;
        } );
    }
    onNewClose = () => {
        this.props.hideModal( 'newUserModal' );
    }
    onManualSort = ( o, s, data ) => {
        this.setState( ( prevState ) => {
            var movedUser = prevState.users.splice( data.oldIndex, 1 )[ 0 ];
            prevState.users.splice( data.newIndex, 0, movedUser );
            prevState.users = prevState.users.slice( 0 );
            var orderedUserIds = prevState.users.map( user => user.userid );
            this.props.updateFeaturedUserOrder( orderedUserIds );
            return prevState;
        } );
    }



    render() {
        const { fetching, users } = this.state;

        return (
            <section className={ style.usersPage }>
                <Helmet>
                    <title>Admin - Featured Users</title>
                </Helmet>
                <div className={ style.head }>
                    <h2>Users</h2>
                    <div className={ style.controls }>
                        <PrimaryButton
                        label='+ Add New User'
                        onClick={ this.openNewModal } />
                    </div>
                    <div className={ style.tabs }>
                        <Link to='/admin/users' className={ style.tabOption }>View All</Link>
                        <Link to='/admin/users/featured' className={ style.tabOption }
                        data-active={ true }>Featured Users</Link>
                    </div>
                </div>
                <div className={ style.body }>
                    <section className={ style.allUsersList }>
                        <div className={ style.filters }>
                        </div>
                        { fetching ?
                            <LoadingReplace />
                            :
                            <FeaturedUsersTable
                            users={ users }
                            updateUser={ this.directUpdateUser }
                            openEditModal={ this.openEditModal }
                            onChange={ this.onManualSort } />
                        }
                        { this.state.userInEdit &&
                            <EditUserModal closeModal={ this.onEditClose }
                            onSubmit={ this.onEditSubmit }
                            user={ this.state.userInEdit } />
                        }
                    </section>
                </div>
                <NewUserModal closeModal={ this.onNewClose }
                onSubmit={ this.onNewSubmit } />
            </section>
        );
    }
}

const mapDispatchToProps = ( dispatch ) => {
    return {
        showModal: ( modalName ) => {
            dispatch( showModal( modalName ) );
        },
        hideModal: ( modalName ) => {
            dispatch( hideModal( modalName ) );
        },
        createUser: ( data ) => {
            data.user = dAPI.clean.admin.user( data.user );
            return dAPI.post( '/auth/signup', data );

        },
        getUsers: ( queryObject ) => {
            return dAPI.get( '/admin/users', queryObject );

        },
        updateUser: ( userid, data ) => {
            return dAPI.patch( `/users/${ userid }`, dAPI.clean.admin.user( data ) );

        },
        updateUserAffiliateCode: ( userid, data ) => {
            return dAPI.post( `/users/${ userid }/affiliatecode`, data );

        },
        updateFeaturedUserOrder: ( newOrder ) => {
            return dAPI.patch( '/admin/users/orderFeatured', { orderedUserIds: newOrder } );

        },
    };
};

export default connect( null, mapDispatchToProps )( FeaturedUsersView );
